module.exports = __webpack_public_path__ + "static/media/kn.ad3fa330.webp";